/**
 * GameEngineEnv enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file GameEngineEnv.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum GameEngineEnv {
  NODE = "NODE",  //engine is running in a node environment
  JS = "JS",      //engine is running in a plain js environment like the web
};
